'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var dom = {};

dom.window = $(window);
dom.document = $(document);
dom.html = $('html');
dom.head = $('head');
dom.body = $('body');

// Deprecated, do not use, use trigger-custom-event system module instead
dom.triggerCustomEvent = function(e) {

	console.log('custom event triggered: ' + e.type, e);

	dom.document.triggerHandler(e);

};

module.exports = dom;
